export function getAccountRoles(account) {
  return Array.isArray(account?.idTokenClaims?.roles)
    ? account.idTokenClaims.roles.map((role) => String(role))
    : [];
}

export function isAdminAccount(account) {
  return getAccountRoles(account)
    .map((role) => role.toLowerCase())
    .includes("admin");
}
